import React, { FC } from "react"
import { Card, Grid, Group, Text, useMantineTheme } from "@mantine/core"
import { IconBatteryCharging } from "@tabler/icons-react"
import BatteryStatus from "../battery-status/BatteryStatus"
import { HealthDocument } from "../../../../contexts/health-context"
import { useLanguage } from "../../../../contexts/language-context"
import DeviceStatusBadge from "../device-status-badge/DeviceStatusBadge"

type DeviceSummaryServicesCardProps = {
    health: HealthDocument
}

const DeviceSummaryServicesCard: FC<DeviceSummaryServicesCardProps> = ({ health }) => {
    const { L } = useLanguage()
    const theme = useMantineTheme()

    return (
        <Card p="1rem" bg={theme.colorScheme === "dark" ? "dark.5" : "gray.1"} shadow="">
            <Grid align="center">
                <Grid.Col span={12}>
                    <Text color="dimmed" weight="bold" sx={theme => ({ fontFamily: theme.headings.fontFamily })}>
                        <Group spacing="xs">
                            <IconBatteryCharging size={20} />
                            {L("Device")}
                        </Group>
                    </Text>
                </Grid.Col>
                <Grid.Col span={4}>
                    <Text color="dimmed">{L("Status")}</Text>
                </Grid.Col>
                <Grid.Col span={8}>
                    <DeviceStatusBadge health={health} />
                </Grid.Col>
                {typeof health.battery === "number" && (
                    <>
                        <Grid.Col span={4}>
                            <Text color="dimmed">
                                {L("Battery")}
                            </Text>
                        </Grid.Col>
                        <Grid.Col span={6}>
                            <BatteryStatus value={health.battery} charging={health.charging} />
                        </Grid.Col>
                    </>
                )}
            </Grid>
        </Card>
    )
}

export default DeviceSummaryServicesCard
